// extracted by mini-css-extract-plugin
export default {"MyPageContainer":"mypage_MyPageContainer__UTd2E","myPageWrapper":"mypage_myPageWrapper__Uj1nX"};